module.exports = __webpack_public_path__ + "static/media/user3.aaaf3cf0.jpg";